import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ReplyInTaskStore } from '../stores/replyInTaskStore';

export const useReplyInTaskStore = () => useContext<{
  replyInTaskStore: ReplyInTaskStore
}>(StoreContext);
